import { render, staticRenderFns } from "./GuidanceAndAppointment.vue?vue&type=template&id=b9247b90&scoped=true&"
import script from "./GuidanceAndAppointment.vue?vue&type=script&lang=js&"
export * from "./GuidanceAndAppointment.vue?vue&type=script&lang=js&"
import style0 from "./GuidanceAndAppointment.vue?vue&type=style&index=0&id=b9247b90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9247b90",
  null
  
)

export default component.exports